import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, NgForm, Validators} from '@angular/forms';
import {Response} from '@angular/http';
import {AdminService} from '../../../services/admin.service';
import {ComponentBackgroundService} from '../../../services/component-background.service';
import {RenamePositionComponent} from '../../views/view-group/popups/rename-position/rename-position.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-create-position',
  templateUrl: './create-position.component.html',
  styleUrls: ['./create-position.component.css']
})
export class CreatePositionComponent implements OnInit {
  showList = true;
  public successInfo = false;
  public errorInfo = false;
  newPosName = 'No name';
  // groupName = 'No name';
  // groupList: any;
  // selectedGroup = 'Select';
  // private groupIDForm = null;

  posLoaded = false;
  errorGetPos = false;

  public formGroup: FormGroup;

  public allPositions: any[] = [];

  constructor(private adminService: AdminService,
              private modalService: NgbModal,
              public componentBackgroundService: ComponentBackgroundService) {
  }

  ngOnInit() {

    this.posLoaded = false;
    this.errorGetPos = false;

    this.formGroup = new FormGroup({
      Position: new FormControl('', [
        Validators.required,
        Validators.minLength(5),
        Validators.pattern(/^((?!\s{2}).)*$/)
      ])
    });


    this.adminService.getAllPositions().subscribe(
      (res: any) => {
        this.allPositions = res.body;
        this.errorGetPos = false;
        this.posLoaded = true;
      },
      () => {
        this.errorGetPos = true;
        this.posLoaded = true;
      }
    );

  }


  changeBack() {
    this.showList = !this.showList;
  }

  onSubmit() {
    this.newPosName = this.formGroup.get('Position').value;
    const position = {
      name: this.formGroup.get('Position').value
    };
    this.adminService.createPositionGlobal(position).subscribe(
      (response: any) => {
        if (response.status === 200) {

          this.allPositions.push(response.body);

          this.successInfo = true;
          this.errorInfo = false;
        }
      },
      () => {
        this.successInfo = false;
        this.errorInfo = true;
      }
    );
  }

  openEditPos(pos) {
    const modalRef = this.modalService.open(RenamePositionComponent);
    modalRef.componentInstance.setPositionForRename(pos);
    // modalRef.componentInstance.setGroup(this.group);
  }

  setPosStatus(pos, posStatus) {
    this.adminService.setPositionStatus(pos.id, posStatus).subscribe(
      (response: any) => {
        if (response.status === 200) {
          pos.active = response.body.active;
        }
      },
      () => {
      }
    );
  }

  filterBy(prop: string) {
    if (this.allPositions !== undefined) {
      return this.allPositions.sort((a, b) => a[prop].toLowerCase() > b[prop].toLowerCase() ? 1 : a[prop].toLowerCase() === b[prop].toLowerCase() ? 0 : -1);
    }

  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-position/create-position.component.ts